export const CURRENT_LANGUAGE_LOCAL_STORAGE_KEY = 'Translate:CurrentLanguage';
